import React from 'react';
import URL from '../configs/baseUrl';
import { adminAccessGroupSlugs } from '../configs/accessGroup';
import { isAccessGroupExist } from '../utils/accessGroup';

const RouteComp = (lazyImport) => {
  return React.lazy(() => {
    return lazyImport;
  });
};

const noSidebarRoute = [
  // public Routes
  {
    path: URL.ANALYZER_PRINT(':analyzerId'),
    component: RouteComp(import('./analyzerPrint')),
    isPublic: true,
  },
  {
    path: URL.AUTH,
    component: RouteComp(import('./auth')),
    isPublic: true,
  },
  {
    path: URL.COMING,
    component: RouteComp(import('./comingSoon')),
    isPublic: true,
  },
  {
    path: URL.COMPONENTS,
    component: RouteComp(import('./components')),
    isPublic: true,
  },
  {
    path: URL.TOS,
    component: RouteComp(import('./tos')),
    isPublic: true,
  },
  {
    path: URL.PRIVACYPOLICY,
    component: RouteComp(import('./privacyPolicy')),
    isPublic: true,
  },
  {
    path: URL.LANDING,
    component: RouteComp(import('./auth')),
    isPublic: true,
  },
];

const sidebarRoutes = [
  // private route
  {
    path: URL.SOCIAL_ACCOUNTS,
    component: RouteComp(import('./socialAccounts')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.USERS,
    component: RouteComp(import('./users')),
    isPublic: false,
    isHasAccess: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_USER,
    }),
  },
  {
    path: URL.CONTACTS,
    component: RouteComp(import('./contacts')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.TEAMS,
    component: RouteComp(import('./teams')),
    isPublic: false,
    isHasAccess: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_TEAM,
    }),
  },
  {
    path: URL.PAYMENTS,
    component: RouteComp(import('./payments')),
    isPublic: false,
    isHasAccess: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_PAYMENT,
    }),
  },
  {
    path: URL.ACCOUNTS,
    component: RouteComp(import('./accounts')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.MEMBERS,
    component: RouteComp(import('./members')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.TEAM_SETTINGS,
    component: RouteComp(import('./teamSetting')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.LICENSES,
    component: RouteComp(import('./licenses')),
    isPublic: false,
    isHasAccess: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_LICENSE,
    }),
  },
  {
    path: URL.NOTIFICATIONS,
    component: RouteComp(import('./notifications')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.SCRIBERS,
    component: RouteComp(import('./scribers')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.PROMOTER,
    component: RouteComp(import('./promoter')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.INTEGRATOR,
    component: RouteComp(import('./integrators')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.ANALYZER_DETAIL(':analyzerId'),
    component: RouteComp(import('./analyzerDetail')),
    isPublic: false,
    isHasAccess: true,
  },
  // {
  //   path: URL.ANALYZER_REPORT(':analyzerId'),
  //   component: RouteComp(import('./analyzerDetail')),
  //   isPublic: false,
  //   isHasAccess: true,
  // },
  {
    path: URL.ANALYZER_POS(':analyzerId'),
    component: RouteComp(import('./analyzerDetail')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.ANALYZER,
    component: RouteComp(import('./analyzer')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.REFINER,
    component: RouteComp(import('./refiner')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.SETTING,
    component: RouteComp(import('./setting')),
    isPublic: false,
    isHasAccess: true,
  },
  {
    path: URL.LANDING,
    component: RouteComp(import('./dashboard')),
    isPublic: false,
    isHasAccess: true,
    // isHasAccess: isTeamAccessGroupExist({
    //   slug: teamAccessGroupsSlugs.DASHBOARD,
    // }),
  },
];

export { noSidebarRoute, sidebarRoutes };
